import { useEffect, useState } from 'react';

/**
 * The value, once it has stopped changing for `delay` ms.
 *
 * For a search box that drives a request: typing "pizza" should be one query,
 * not five. Returns the current value immediately on mount, so the first render
 * is not an artificial blank.
 */
export const useDebouncedValue = <T>(value: T, delay: number) => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timeout = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timeout);
  }, [value, delay]);

  return debounced;
};
